<template>
<v-dialog
    v-model="dialog"
    @keydown.esc="cancel"
    @click:outside="cancel"
    width="50%"
  >
    <v-card class="animation-background" min-height="400px">
      <v-toolbar dark dense flat>
        <v-toolbar-title class="text-body-2 font-weight-bold grey--text">
          {{ title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          class="body-2 font-weight-bold"
          elevation="0"
          @click.native="agree"
          >Aceptar</v-btn
        >
      </v-toolbar>
      <v-card-text
        v-show="!!message"
        class="pa-4 black--text text-h4 text-center"
        v-html="message"
      ></v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.animation-background {
    background-color: white;
    background-image: url(/public/images/animations/error.gif);
    background-position: center calc(100% + 170px); /*Positioning*/
    background-repeat: no-repeat; /*Prevent showing multiple background images*/
}
</style>


<script lang="ts">
import { ApiError } from "@/services/BaseService";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class extends Vue {
    dialog = false;
    resolve: ((value: boolean) => void) | null = null;
    reject: ((value: boolean) => void) | null = null;
    message: string | null = null;
    title: string | null = null;

    open(title: string, error: Error | ApiError | string) {
        this.dialog = true;
        this.title = title;
        if (error instanceof ApiError) {
            this.message = error.errorMessage;
        } else if (error instanceof Error) {
            this.message = error.message;
        } else {
            this.message = error;
        }

        this.message = this.message || "Error desconocido";

        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    agree() {
        if (this.resolve) {
            this.resolve(true);
        }

        this.dialog = false;
    }

    cancel() {
        if (this.resolve) {
            this.resolve(false);
        }

        this.dialog = false;
    }
}
</script>
